import Workspace from '../../types/Workspace';

// The route's :spaceId is the space's publicId (getSpaceDefaultRoute), but getWorkspaceById
// also accepts the numeric id, so an old link may still carry that. Either one identifies it.
export const isSpaceForRoute = (space: Pick<Workspace, 'id' | 'publicId'> | undefined, routeSpaceId?: string) => {
  if (!space || !routeSpaceId) return false;
  return space.publicId === routeSpaceId || String(space.id) === routeSpaceId;
};
